<template>
	<b-row align-v="center">
		<slot name="search"></slot>
		<b-col
			:cols="colSize('agent_id', 'cols', 6)"
			:sm="colSize('agent_id', 'sm', 6)"
			:md="colSize('agent_id', 'md', 3)"
			:lg="colSize('agent_id', 'lg', 2)"
			:order="getFieldOrder('agent_id')"
			v-if="!hide('agent_id')"
		>
			<b-form-group :class="getRequiredFields('agent_id')" :label="$t('COMMON.LBL_AGENT')">
				<selectField
					v-if="multiple_agent"
					:data="searchForm.agent_ids"
					:selection="agent_selection"
					@update="
						(v) => {
							searchForm.agent_ids = v;
						}
					"
					:multiple="true"
					:clearable="true"
					:custom_selection="1"
					:is_view="disable('agent_id')"
					:show_all_label="true"
					:inc_inactive="true"
					@mouseenter="getAgentSelection"
				></selectField>
				<selectField
					v-if="!multiple_agent"
					:data="searchForm.agent_id"
					:selection="agent_selection"
					@update="
						(v) => {
							searchForm.agent_id = v;
						}
					"
					:clearable="true"
					:custom_selection="1"
					:is_view="disable('agent_id')"
					:show_all_label="true"
					:inc_inactive="true"
					@focus="getAgentSelection"
				></selectField>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('customer_id', 'cols', 6)"
			:sm="colSize('customer_id', 'sm', 6)"
			:md="colSize('customer_id', 'md', 4)"
			:lg="colSize('customer_id', 'lg', 4)"
			:order="getFieldOrder('customer_id')"
			v-if="!hide('customer_id')"
		>
			<b-form-group :class="getRequiredFields('customer_id')" :label="$t('COMMON.SEARCHFORM.LBL_CUSTOMER_NAME')">
				<selectField
					:data="searchForm.customer_ids"
					:selection="customerSelection"
					@update="
						(v) => {
							searchForm.customer_ids = v;
						}
					"
					:multiple="true"
					:clearable="true"
					:inc_inactive="true"
					value_key="customer_agent_id"
					:enable_search="true"
					:custom_selection="1"
					@search="getCustomerCompanySelection"
					:show_all_label="true"
					field_type="customer"
					v-if="use_marking_selection == 1"
				></selectField>
				<b-form-input
					v-if="use_marking_selection == 0"
					size="sm"
					:placeholder="$CoreSettingsJs.placeHolderHandle($t('COMMON.LBL_CUSTOMER_NAME'))"
					v-model="searchForm.customer_name"
				></b-form-input>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('customer_marking_id', 'cols', 6)"
			:sm="colSize('customer_marking_id', 'sm', 6)"
			:md="colSize('customer_marking_id', 'md', 4)"
			:lg="colSize('customer_marking_id', 'lg', 3)"
			:order="getFieldOrder('customer_marking_id')"
			v-if="!hide('customer_marking_id')"
		>
			<b-form-group :class="getRequiredFields('customer_marking_id')" :label="$t('COMMON.LBL_MARKING')">
				<selectField
					v-if="use_marking_selection == 1"
					:data="searchForm.customer_marking_ids"
					:selection="markingSelection"
					value_key="customer_marking_agent_id"
					:multiple="true"
					:clearable="true"
					:inc_inactive="true"
					:wms="1"
					:custom_selection="1"
					:show_all_label="true"
					:enable_search="true"
					@search="getMarkingSelection"
					@focus="getMarkingSelection"
					@update="
						(v) => {
							searchForm.customer_marking_ids = v;
						}
					"
				></selectField>
				<b-form-input
					v-if="use_marking_selection == 0"
					size="sm"
					:placeholder="$CoreSettingsJs.placeHolderHandle($t('COMMON.SEARCHFORM.LBL_MARKING'))"
					v-model="searchForm.marking"
					:formatter="
						(v) => {
							return v.toUpperCase();
						}
					"
					lazy-formatter
					@keydown.enter.prevent
				></b-form-input>
			</b-form-group>
		</b-col>
		<b-col
			:order="getFieldOrder('delivery_address_id')"
			v-if="!hide('delivery_address')"
			:cols="colSize('delivery_address_id', 'cols', 6)"
			:sm="colSize('delivery_address_id', 'sm', 6)"
			:md="colSize('delivery_address_id', 'md', 4)"
			:lg="colSize('delivery_address_id', 'lg', 3)"
		>
			<b-form-group :class="getRequiredFields('delivery_address_id')" :label="$t('COMMON.LBL_DELIVERY_ID')">
				<selectField
					:data="searchForm.delivery_address_ids"
					:selection="delivery_address_selection"
					@update="
						(v) => {
							searchForm.delivery_address_ids = v;
						}
					"
					:multiple="true"
					:clearable="true"
					@focus="getDeliveryAddressSelection()"
					text_key="full_delivery_id"
					value_key="delivery_address_agent_id"
					field_type="delivery_address"
					:wms="1"
					:custom_selection="1"
					:show_all_label="true"
					:inc_inactive="true"
				>
				</selectField>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('msm_id', 'cols', 6)"
			:sm="colSize('msm_id', 'sm', 6)"
			:md="colSize('msm_id', 'md', 3)"
			:lg="colSize('msm_id', 'lg', 2)"
			:order="getFieldOrder('msm_id')"
			v-if="!hide('msm_id')"
		>
			<b-form-group :class="getRequiredFields('msm_id')" :label="$t('COMMON.SEARCHFORM.LBL_MAIN_SALESMAN')">
				<selectField
					:data="searchForm.msm_ids"
					:selection="msmSelection"
					value_key="msm_agent_id"
					@update="
						(v) => {
							searchForm.msm_ids = v;
						}
					"
					:multiple="true"
					:clearable="true"
					@focus="getMsmSelection"
					:custom_selection="1"
					:show_all_label="true"
					:inc_inactive="true"
				></selectField>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('sm_id', 'cols', 6)"
			:sm="colSize('sm_id', 'sm', 6)"
			:md="colSize('sm_id', 'md', 3)"
			:lg="colSize('sm_id', 'lg', 2)"
			:order="getFieldOrder('sm_id')"
			v-if="!hide('sm_id')"
		>
			<b-form-group :class="getRequiredFields('sm_id')" :label="$t('COMMON.SEARCHFORM.LBL_SALESMAN')">
				<selectField
					:data="searchForm.sm_ids"
					:selection="smSelection"
					value_key="sm_agent_id"
					:multiple="true"
					:clearable="true"
					:show_all_label="true"
					:custom_selection="1"
					:inc_inactive="true"
					@focus="getSmSelection"
					@update="
						(v) => {
							searchForm.sm_ids = v;
						}
					"
				></selectField>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('company_id', 'cols', 6)"
			:sm="colSize('company_id', 'sm', 6)"
			:md="colSize('company_id', 'md', 3)"
			:lg="colSize('company_id', 'lg', 2)"
			:order="getFieldOrder('company_id')"
			v-if="!hide('company_id')"
		>
			<b-form-group :class="getRequiredFields('company_id')" :label="$t('COMMON.SEARCHFORM.LBL_COMPANY')">
				<selectField
					:data="searchForm.company_ids"
					:selection="companySelection"
					value_key="company_agent_id"
					@update="
						(v) => {
							searchForm.company_ids = v;
						}
					"
					:multiple="true"
					:clearable="true"
					:custom_selection="1"
					:inc_inactive="true"
					@focus="getCompanySelection"
					:show_all_label="true"
				></selectField>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('company_group_id', 'cols', 6)"
			:sm="colSize('company_group_id', 'sm', 6)"
			:md="colSize('company_group_id', 'md', 3)"
			:lg="colSize('company_group_id', 'lg', 2)"
			:order="getFieldOrder('company_group_id')"
			v-if="!hide('company_group_id')"
		>
			<b-form-group :class="getRequiredFields('company_group_id')" :label="$t('COMMON.SEARCHFORM.LBL_COMPANY_GROUP')">
				<selectField
					:data="searchForm.company_group_ids"
					:selection="companyGroupSelection"
					@update="
						(v) => {
							searchForm.company_group_ids = v;
						}
					"
					value_key="company_group_agent_id"
					:multiple="true"
					:clearable="true"
					:custom_selection="1"
					@focus="getCompanyGroup"
					:show_all_label="true"
					:inc_inactive="true"
				></selectField>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('warehouse_id', 'cols', 6)"
			:sm="colSize('warehouse_id', 'sm', 6)"
			:md="colSize('warehouse_id', 'md', 3)"
			:lg="colSize('warehouse_id', 'lg', 2)"
			:order="getFieldOrder('warehouse_id')"
			v-if="!hide('warehouse_id')"
		>
			<b-form-group :class="getRequiredFields('warehouse_id')" :label="$t('COMMON.LBL_WAREHOUSE')">
				<selectField
					v-if="!multiple_warehouse"
					:data="searchForm.warehouse_id"
					:selection="warehouseSelection"
					:classname="
						!$CoreSettingsJs.emptyObjectValidation(searchFormValid) && !$CoreSettingsJs.emptyObjectValidation(searchFormValid.warehouse_id_state)
							? $CoreSettingsJs.setRequiredErrorBorder(searchFormValid.warehouse_id_state, 0, 1)
							: ``
					"
					@update="
						(v) => {
							searchForm.warehouse_id = v;
						}
					"
					:clearable="true"
					:custom_selection="1"
					:is_view="disable('warehouse_id')"
					@focus="getWarehouseSelection()"
					:show_all_label="true"
					:inc_inactive="true"
					@change="resetState('warehouse_id_state', 'warehouse_id_error')"
				></selectField>
				<selectField
					v-if="multiple_warehouse"
					:data="searchForm.warehouse_ids"
					:selection="warehouseSelection"
					@update="
						(v) => {
							searchForm.warehouse_ids = v;
						}
					"
					:multiple="true"
					:clearable="true"
					:custom_selection="1"
					:inc_inactive="true"
					:classname="
						!$CoreSettingsJs.emptyObjectValidation(searchFormValid) && !$CoreSettingsJs.emptyObjectValidation(searchFormValid.warehouse_id)
							? $CoreSettingsJs.setRequiredErrorBorder(searchFormValid.warehouse_id.state, 0, 1)
							: ``
					"
					@focus="getWarehouseSelection()"
					:is_view="disable('warehouse_id')"
					:show_all_label="true"
				></selectField>
				<b-form-invalid-feedback
					v-if="!$CoreSettingsJs.emptyObjectValidation(searchFormValid) && !$CoreSettingsJs.emptyObjectValidation(searchFormValid.warehouse_id_state)"
					:state="searchFormValid.warehouse_id_state"
					v-text="searchFormValid.warehouse_id_error"
				></b-form-invalid-feedback>
			</b-form-group>
		</b-col>
		<b-col
			:cols="colSize('status', 'cols', 6)"
			:sm="colSize('status', 'sm', 6)"
			:md="colSize('status', 'md', 2)"
			:lg="colSize('status', 'lg', 2)"
			:order="getFieldOrder('status')"
			v-if="!hide('status')"
		>
			<b-form-group :class="getRequiredFields('status')" :label="$t('COMMON.LBL_STATUS')">
				<selectField
					:data="searchForm.status"
					:selection="$CoreJs.statusSelection"
					@update="
						(v) => {
							searchForm.status = v;
						}
					"
					value_key="item"
					text_key="name"
					:show_all_label="true"
				></selectField>
			</b-form-group>
		</b-col>
		<b-col
			cols="12"
			sm="2"
			md="4"
			:lg="!hide('search_button') && !hideReset && !hideExportExcel ? 4 : 2"
			class="pt-3"
			:order="getFieldOrder('search_button')"
			v-if="!hide('search_button') || !hideReset || !hideExportExcel"
		>
			<div class="d-flex">
				<b-button v-if="!hide('search_button')" variant="primary" size="sm" type="submit" class="text-nowrap" :class="$CoreSettingsJs.isMobile() ? `btn-icon` : ``">
					<b-icon-search></b-icon-search>
					<span class="ml-1" v-if="!$CoreSettingsJs.isMobile()" v-text="$t('COMMON.BTN_SEARCH')"></span>
				</b-button>
				<b-button v-if="!hideReset" class="ml-1" variant="teal" size="sm" :class="$CoreSettingsJs.isMobile() ? 'btn-icon' : ''" @click="$emit('resetSearchForm')">
					<b-icon-arrow-repeat></b-icon-arrow-repeat>
					<span class="ml-1" v-if="!$CoreSettingsJs.isMobile()" v-text="$t('COMMON.BTN_RESET')"></span>
				</b-button>
				<b-button v-if="!hideExportExcel" class="ml-1" size="sm" variant="excel" :class="$CoreSettingsJs.isMobile() ? 'btn-icon' : ''" @click="$emit('exportExcel')">
					<b-icon-file-excel-fill></b-icon-file-excel-fill>
					<span class="ml-1" v-if="!$CoreSettingsJs.isMobile()" v-text="$t('COMMON.BTN_EXPORT_EXCEL')"></span>
				</b-button>
			</div>
		</b-col>
	</b-row>
</template>

<script>
import searchButton from "@/view/content/form/SearchFormButton.vue";
export default {
	name: "SearchFormStandardFilter",
	props: {
		searchForm: null,
		multiple_agent: {
			type: Boolean,
			default() {
				return true;
			}
		},
		multiple_warehouse: {
			type: Boolean,
			default() {
				return false;
			}
		},
		use_marking_selection: {
			type: Number,
			default: 1
		},
		hideField: {
			type: Array,
			default() {
				return [];
			}
		},
		sortField: {
			type: Object,
			default() {
				return {};
			}
		},
		master_page: {
			type: Boolean,
			default() {
				return false;
			}
		},
		required_fields: {
			type: Array,
			default() {
				return [];
			}
		},
		searchFormValid: {
			type: Object,
			default() {
				return {};
			}
		},
		disableField: {
			type: Array,
			default() {
				return [];
			}
		},
		col_size: {
			type: Object,
			default() {
				return {};
			}
		},
		hideReset: {
			type: Boolean,
			default() {
				return true;
			}
		},
		hideExportExcel: {
			type: Boolean,
			default() {
				return true;
			}
		}
	},
	components: {
		searchButton
	},
	data() {
		return {
			msmSelection: [],
			smSelection: [],
			companySelection: [],
			companyGroupSelection: [],
			markingSelection: [],
			customerSelection: [],
			agent_selection: [],
			delivery_address_selection: [],
			warehouseSelection: [],
			search_customer_debounce_timer: null,
			search_marking_debounce_timer: null
		};
	},
	watch: {
		"searchForm.agent_id"(new_val, old_val) {
			if (!this.$CoreSettingsJs.emptyObjectValidation(new_val) && !this.$CoreSettingsJs.emptyObjectValidation(old_val) && new_val != old_val) {
				this.resetField("customer_ids", []);
				this.resetField("customer_marking_ids", []);
				this.resetField("delivery_address_ids", []);
				this.resetField("msm_ids", []);
				this.resetField("sm_ids", []);
				this.resetField("company_ids", []);
				this.resetField("company_group_ids", []);
			}
		}
	},
	computed: {
		computed_msm_id() {
			return this.searchForm.msm_ids.map((x) => x.split("-")[0]);
		}
	},
	methods: {
		resetField(field, val) {
			if (!this.$CoreSettingsJs.emptyObjectValidation(this.searchForm[field])) {
				this.searchForm[field] = val;
			}
		},
		disable(field_name) {
			return !this.$CoreSettingsJs.emptyObjectValidation(this.disableField) && this.disableField.includes(field_name) ? 1 : 0;
		},
		getRequiredFields(field_name) {
			return !this.$CoreSettingsJs.emptyObjectValidation(this.required_fields) && this.required_fields.includes(field_name) ? `required-fields` : ``;
		},
		getFieldOrder(field_name) {
			return !this.$CoreSettingsJs.emptyObjectValidation(this.sortField) && !this.$CoreSettingsJs.emptyObjectValidation(this.sortField[field_name]) ? parseInt(this.sortField[field_name]) : 0;
		},
		colSize(field_name, size_type, default_size) {
			return !this.$CoreSettingsJs.emptyObjectValidation(this.col_size) &&
				!this.$CoreSettingsJs.emptyObjectValidation(this.col_size[field_name]) &&
				!this.$CoreSettingsJs.emptyObjectValidation(this.col_size[field_name][size_type])
				? this.col_size[field_name][size_type]
				: default_size;
		},
		hide(field_name) {
			return (!this.$CoreSettingsJs.emptyObjectValidation(this.hideField) && this.hideField.includes(field_name)) ||
				(this.master_page && !["status", "agent_id", "msm_id", "search_button", "warehouse_id"].includes(field_name))
				? true
				: false;
		},
		async getCustomerCompanySelection(keyword = null) {
			if (this.search_customer_debounce_timer) {
				clearTimeout(this.search_customer_debounce_timer);
			}

			this.search_customer_debounce_timer = setTimeout(async () => {
				this.customerSelection = await this.$CoreJs.customerSelection({
					agent_ids: this.searchForm.agent_ids,
					agent_id: this.searchForm.agent_id,
					ignore_status_filter: 1,
					name: keyword
				});
			}, 500);
		},
		async getMarkingSelection(keyword = null, customer_marking_ids = []) {
			if (this.search_marking_debounce_timer) {
				clearTimeout(this.search_marking_debounce_timer);
			}

			this.search_marking_debounce_timer = setTimeout(async () => {
				this.markingSelection = await this.$CoreJs.markingSelection({
					agent_ids: this.searchForm.agent_ids,
					customer_ids: this.searchForm.customer_ids,
					customer_marking_ids: customer_marking_ids,
					ignore_status_filter: 1,
					name: keyword
				});
			}, 500);
		},
		async getMsmSelection() {
			this.msmSelection = await this.$CoreJs.mainSalesmanSelection({
				agent_ids: this.searchForm.agent_ids,
				agent_id: this.searchForm.agent_id,
				ignore_status_filter: 1
			});
		},
		async getCompanySelection() {
			this.companySelection = await this.$MasterDataJs.companySelection({
				agent_ids: this.searchForm.agent_ids,
				agent_id: this.searchForm.agent_id,
				msm_ids: this.searchForm.msm_ids,
				ignore_status_filter: 1
			});
		},
		async getCompanyGroup() {
			this.companyGroupSelection = await this.$CoreJs.companyGroupSelection({
				company_ids: this.searchForm.company_ids,
				agent_ids: this.searchForm.agent_ids,
				ignore_status_filter: 1
			});
		},
		async getSmSelection() {
			this.smSelection = await this.$CoreJs.salesmanSelection({
				agent_ids: this.searchForm.agent_ids,
				msm_ids: this.searchForm.msm_ids,
				ignore_status_filter: 1
			});
		},
		async getAgentSelection() {
			this.agent_selection = await this.$CoreJs.agentSelection({
				ignore_status_filter: 1
			});
		},
		async getDeliveryAddressSelection() {
			let response = await this.$CoreJs.deliveryAddressSelection({
				customer_ids: this.searchForm.customer_ids,
				customer_marking_ids: this.searchForm.customer_marking_ids,
				ignore_status_filter: 1
			});
			this.delivery_address_selection = response;
		},
		async getWarehouseSelection() {
			this.warehouseSelection = await this.$CoreJs.warehouseSelection({ ignore_status_filter: 1 });
		},
		resetState(state_name, error_name) {
			if (!this.$CoreSettingsJs.emptyObjectValidation(this.searchFormValid) && !this.$CoreSettingsJs.emptyObjectValidation(this.searchFormValid[state_name])) {
				this.$CoreSettingsJs.resetState(this.searchFormValid, state_name, error_name);
			}
		}
	}
};
</script>
